import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import { formatItems } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useAddShippingInfoEvent = () => {
  const isGTMEnabled = useFeatureFlag("gtm");
  const handleAddShippingInfoEvent = useCallback(
    (cart) => {
      if (!isGTMEnabled) {
        return;
      }
      const { cartTotal, lineItems, couponName } = cart;
      sendGTMEvent({
        event: "add_shipping_info",
        currency: CURRENCY_CODE,
        value: cartTotal?.total,
        coupon: couponName || "",
        shipping_tier: "Ground",
        items: formatItems(lineItems, couponName),
      });
    },
    [isGTMEnabled]
  );

  return { handleAddShippingInfoEvent };
};

export default useAddShippingInfoEvent;
